export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.073 3.5a2.5 2.5 0 012.236 1.382l2.249 4.497c.39-.104.77-.213 1.136-.331l.612 1.904c-.422.135-.858.26-1.306.378V20a1 1 0 01-1 1h-4a1 1 0 01-1-1v-2H8v2a1 1 0 01-1 1H3a1 1 0 01-1-1v-8.67a25.137 25.137 0 01-1.306-.378l.612-1.904c.367.118.746.227 1.135.33l2.25-4.496A2.5 2.5 0 016.927 3.5h10.146zM20 11.781c-4.985.957-11.015.957-16 0V19h2v-2a1 1 0 011-1h10a1 1 0 011 1v2h2v-7.219zM6.927 5.5a.5.5 0 00-.448.276L4.451 9.832c4.692.89 10.405.89 15.097 0L17.52 5.776a.5.5 0 00-.448-.276H6.927z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};